// Central test IDs for Mindstorm Productions site
export const NAV = {
    root: 'nav-root',
    logo: 'nav-logo',
    link: (id) => `nav-link-${id}`,
    ctaContact: 'nav-cta-contact',
    mobileToggle: 'nav-mobile-toggle',
    mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
    root: 'hero-root',
    headline: 'hero-headline',
    subheading: 'hero-subheading',
    description: 'hero-description',
    ctaStart: 'hero-cta-start-project',
    ctaPortfolio: 'hero-cta-view-portfolio',
};

export const ABOUT = { root: 'about-root', title: 'about-title', body: 'about-body' };

export const STATS = {
    root: 'stats-root',
    item: (id) => `stat-item-${id}`,
    value: (id) => `stat-value-${id}`,
};

export const SERVICES = {
    root: 'services-root',
    card: (id) => `service-card-${id}`,
    difference: 'difference-root',
    diffCard: (id) => `difference-card-${id}`,
};

export const PORTFOLIO = {
    root: 'portfolio-root',
    filter: (id) => `portfolio-filter-${id}`,
    item: (id) => `portfolio-item-${id}`,
};

export const CLIENTS = { root: 'clients-root', logo: (id) => `client-logo-${id}` };

export const CONTACT = {
    root: 'contact-root',
    form: 'contact-form',
    name: 'contact-input-name',
    email: 'contact-input-email',
    phone: 'contact-input-phone',
    company: 'contact-input-company',
    eventType: 'contact-input-event-type',
    message: 'contact-input-message',
    submit: 'contact-submit',
    whatsapp: 'contact-whatsapp',
    phoneLink: 'contact-phone-link',
    emailLink: 'contact-email-link',
    instagram: 'contact-instagram-link',
};

export const FOOTER = {
    root: 'footer-root',
    link: (id) => `footer-link-${id}`,
};

export const WA_FLOAT = 'whatsapp-float-button';
